export default "__VITE_ASSET__d6e4c2bd__"